export const TABLE_TRANSLATIONS = {
  'Basic information': $localize`:@@common.basic_information:Basic Information`,
  Activity: $localize`:@@common.activity:Activity`,
  Name: $localize`:@@common.name:Name`,
  Advertiser: $localize`:@@common.advertiser:Advertiser`,
  Brand: $localize`:@@common.brand:Brand`,
  Status: $localize`:@@common.status:Status`,
  Description: $localize`:@@common.description:Description`,
  'Created At': $localize`:@@common.created_at:Created At`,
  'Marketing Information': $localize`:@@common.marketing_information:Marketing Information`,
  'Is White': $localize`:@@common.is_white:Is White`,
  Note: $localize`:@@common.note:Note`,
  Category: $localize`:@@common.category:Category`,
  Countries: $localize`:@@common.countries:Countries`,
  Languages: $localize`:@@common.languages:Languages`,
  Language: $localize`:@@common.language:Language`,
  Offer: $localize`:@@common.offer:Offer`,
  Default: $localize`:@@common.is_default:Is Default`,
  Source: $localize`:@@common.source:Source`,
  Affiliate: $localize`:@@common.affiliate:Affiliate`,
  Hash: $localize`:@@common.hash:Hash`,
  Type: $localize`:@@common.type:Type`,
  Content: $localize`:@@common.content:Content`,
  Archived: $localize`:@@common.archived:Archived`,
  Settings: $localize`:@@common.settings:Settings`,
  Amount: $localize`:@@common.amount:Amount`,
  Comment: $localize`:@@common.comment:Comment`,
  Company: $localize`:@@common.company:Company`,
  'Is Approved': $localize`:@@common.approved:Approved`,
  'Goal Type': $localize`:@@common.goal_type:Goal Type`,
  'Change History': $localize`:@@common.change_history:Change History`,
  'First Name': $localize`:@@common.first_name:First Name`,
  'Last Name': $localize`:@@common.last_name:Last Name`,
  Birthday: $localize`:@@common.birthday:Birthday`,
  Email: $localize`:@@common.email:Email`,
  Phone: $localize`:@@common.phone:Phone`,
  Address: $localize`:@@common.address:Address`,
  Country: $localize`:@@common.country:Country`,
  'System Role': $localize`:@@common.system_role:System Role`,
  'Updated At': $localize`:@@common.updated_at:Updated At`,
  Version: $localize`:@@common.version:Version`,
  Privacy: $localize`:@@offer.privacy:Privacy`,
  Channel: $localize`:@@offer.channel:Channel`,
  incentive: $localize`:@@offer.incentive:Incentive`,
  'Traffic Source': $localize`:@@offer.traffic_source:Traffic Source`,
  'Enable Extra Payout': $localize`:@@offer.enable_extra_payout:Enable Extra Payout`,
  'Hidden From Affiliates': $localize`:@@offer.hide_from_affiliates:Hidden form Affiliates`,
  'Conversion Auto Approve': $localize`:@@offer.conversion_auto_approve:Conversion Auto Approve`,
  'Multiple Conversion': $localize`:@@offer.is_multiple_conversion:Multiple Conversion`,
  'Check Unique': $localize`:@@offer.is_unique:Check Unique`,
  'Preview Url': $localize`:@@offer.preview_url:Preview URL`,
  'Tracking Domain': $localize`:@@offer.tracking_domain:Tracking Domain`,
  'Only Qualified Postbacks': $localize`:@@affiliate.only_qualified_postback:Only Qualified Postbacks`,
  'Affiliate Group': $localize`:@@affiliate.group:Affiliate Group`,
  'Affiliate Manager': $localize`:@@affiliate.manager:Affiliate Manager`,
  'Master Affiliate': $localize`:@@affiliate.master:Master Affiliate`,
  'Last Seen': $localize`:@@common.last_seen:Last Seen`,
  'External ID': $localize`:@@affiliate.external_id:External ID`,
  'Transaction Date': $localize`:@@transaction.start_date:Transaction Date`,
  Period: $localize`:@@common.period:Period`,
  'Goal Types': $localize`:@@common.goal_types:Goal Types`,
  'Divided By Advertiser': $localize`:@@affiliate.divided_by_advertiser:Divided By Advertiser`,
  'Last Execution Date': $localize`:@@affiliate.transaction_last_execution_date:Last Execution Date`,
  Goal: $localize`:@@affiliate.goal:Goal`,
  Answers: $localize`:@@common.answers:Answers`,
  'Company Name': $localize`:@@common.company_name:Company Name`,
  'Affiliate Name': $localize`:@@affiliate.name:Affiliate Name`,
  Group: $localize`:@@common.group:Group`,
  Width: $localize`:@@common.width:Width`,
  Height: $localize`:@@common.height:Height`,
  Image: $localize`:@@common.image:Image`,
  Total: $localize`:@@finance.total:Total`,
  'Total Paid': $localize`:@@finance.total_paid:Total Paid`,
  'Total Commissions': $localize`:@@finance.total_commissions:Total Commissions`,
  'Payment Method': $localize`:@@payment.method:Payment Method`,
  'Payment Currency': $localize`:@@payment.currency:Payment Currency`,
  'Payment Account': $localize`:@@payment.account:Payment Account`,
  'Status Change At': $localize`:@@common.status_change_at:Status Changed At`,
  'Status Changed History': $localize`:@@common.status_changed_history:Status Changed History`,
  'Affiliate(s)': $localize`:@@finance.affiliates:Affiliate(s)`,
  'Affiliate Consolidation': $localize`:@@affiliate.cluster:Affiliate Consolidation`,
  From: $localize`:@@common.from:From`,
  To: $localize`:@@common.to:To`,
  'Status Changed By': $localize`:@@common.status_changed_by:Status Changed By`,
  'Date Filter': $localize`:@@common.date_filter:Date Filter`,
  Earning: $localize`:@@finance.earning:Earning`,
  Files: $localize`:@@common.files:Files`,
  'Payout Model': $localize`:@@conversion.payout_model:Payout Model`,
  Payout: $localize`:@@conversion.payout:Payout`,
  'Revenue Model': $localize`:@@conversion.revenue_model:Revenue Model`,
  Revenue: $localize`:@@conversion.revenue:Revenue`,
  'Sale Amount': $localize`:@@conversion.sale_amount:Sale Amount`,
  'Deposit Amount': $localize`:@@conversion.deposit_amount: Deposit Amount`,
  'Deposit amount': $localize`:@@conversion.deposit_amount: Deposit Amount`,
  'Net Gaming Amount': $localize`:@@conversion.net_gaming_amount:Net Gaming Amount`,
  'Affiliate Source': $localize`:@@affiliate.source:Affiliate Source`,
  'Deposits Count': $localize`:@@common.deposits_count:Deposits Count`,
  'Device Brand': $localize`:@@common.device_brand:Device Brand`,
  'Device Model': $localize`:@@common.device_model:Device Model`,
  'Device Os': $localize`:@@common.device_os:Device OS`,
  'Device Os Version': $localize`:@@common.device_os_version:Device OS Version`,
  Manufacturer: $localize`:@@common.manufacturer:Manufacturer`,
  OS: $localize`:@@common.os:OS`,
  Model: $localize`:@@common.model:Model`,
  'OS Version': $localize`:@@common.os_version:OS Version`,
  'FTD Amount': $localize`:@@conversion.ftd_amount:FTD Amount`,
  'FTD Date': $localize`:@@conversion.ftd_date:FTD Date`,
  'Group Hash': $localize`:@@common.group_hash:Group Hash`,
  'Is Unique': $localize`:@@common.is_unique:Is Unique`,
  'Last Deposit Date': $localize`:@@common.last_deposit_date:Last Deposit Date`,
  'Offer URL': $localize`:@@offer.url:Offer URL`,
  'Phone Verified': $localize`:@@common.phone_verified:Phone Verified`,
  'Redirected Link': $localize`:@@common.redirected_link:Redirected Link`,
  Referer: $localize`:@@common.referrer:Referrer`,
  Region: $localize`:@@common.region:Region`,
  'Requested Link': $localize`:@@common.requested_link:Requested Link`,
  'Sale Status': $localize`:@@common.sale_status:Sale Status`,
  'Approved Payout': $localize`:@@common.sum_approved_payout:Approved Payout`,
  Profit: $localize`:@@common.sum_approved_profit:Profit`,
  'Withdrawal Amount': $localize`:@@common.withdrawal_amount:Withdrawal Amount`,
  Advertisers: $localize`:@@common.advertisers:Advertisers`,
  'Sub Affiliates': $localize`:@@affiliates.sub:Sub Affiliates`,
  Browser: $localize`:@@common.browser:Browser`,
  ' Events Log ID': $localize`:@@common.events_log_id:Events Log ID`,
  '\tEvents Log ID': $localize`:@@common.events_log_id:Events Log ID`,
  'Events Log Type': $localize`:@@common.events_log_type:Events Log Type`,
  Message: $localize`:@@common.message:Message`,
  Namespace: $localize`:@@common.namespace:Namespace`,
  'Program Type': $localize`:@@common.program_type:Program Type`,
  'Payouts List': $localize`:@@common.payouts_list:Payouts List`,
  'For Test': $localize`:@@common.for_test:For Test`,
  'Conversions Updated Count': $localize`:@@conversion.updated_count:Conversions Updated Count`,
  Employee: $localize`:@@common.employee:Employee`,
  'New Payout': $localize`:@@finance.new_payout:New Payout`,
  'New Revenue': $localize`:@@finance.new_revenue:New Revenue`,
  'Old Payout Avg': $localize`:@@finance.old_payout_avg:Old Payout Avg`,
  'Old Revenue Avg': $localize`:@@finance.old_revenue_avg:Old Revenue Avg`,
  Reason: $localize`:@@common.reason:Reason`,
  'Updated Range': $localize`:@@common.updated_range:Updated Range`,
  'Status Change History': $localize`:@@common.status_change_history:Status Change History`,
  'Status Changed At': $localize`:@@common.status_changed_at:Changed At`,
  'Created From': $localize`:@@common.created_from:Created From`,
  'Created To': $localize`:@@common.created_to:Created To`,
  'Earning From': $localize`:@@earning.from:Earning From`,
  'Earning To': $localize`:@@earning.to:Earning To`,
  'Hide Zero Totals': $localize`:@@common.hide_zero_totals:Hide Zero Totals`,
  'Threshold per Affiliate': $localize`:@@common.threshold_per_affiliate:Threshold per Affiliate`,
  'Threshold Per Affiliate': $localize`:@@common.threshold_per_affiliate:Threshold per Affiliate`,
  'Earning ID': $localize`:@@earning.earning_id:Earning ID`,
  Invoice: $localize`:@@common.invoice:Invoice`,
  'Invoice ID': $localize`:@@invoice.id:Invoice ID`,
  'Referal Link': $localize`:@@common.referral_link:Referral Link`,
  Level: $localize`:@@common.level:Level`,
  Report: $localize`:@@common.report:Report`,
  Active: $localize`:@@common.active:Active`,
  'Compare By': $localize`:@@common.compare_by:Compare By`,
  'Conversion Type': $localize`:@@conversion.type:Conversion Type`,
  Formula: $localize`:@@common.formula:Formula`,
  Hint: $localize`:@@common.hint:Hint`,
  'Short Name': $localize`:@@common.short_name:Short Name`,
  Question: $localize`:@@common.question:Question`,
  Required: $localize`:@@common.required:Required`,
  Target: $localize`:@@common.target:Target`,
  Key: $localize`:@@common.key:Key`,
  'Is Default': $localize`:@@common.is_default:Is Default`,
  Reference: $localize`:@@common.reference:Reference`,
  'Media Placement': $localize`:@@common.media_placement:Media Placement`,
  Incentive: $localize`:@@common.incentive:Incentive`,
  'User Agent': $localize`:@@common.user_agent:User Agent`,
  Platform: $localize`:@@common.platform:Platform`,
  'Advertiser External Id': $localize`:@@advertiser.external_id:External Id`,
  'Unapproved Source': $localize`:@@common.unapproved_source:Unapproved Source`,
  'Fee Amount': $localize`:@@common.fee_amount:Fee Amount`,
  'Master Affiliate Fee': $localize`:@@common.master_affiliate_fee:Master Affiliate Fee`,
  'Click Created At': $localize`:@@click.created_at:Click Created At`,
  'AFM Date': $localize`:@@common.afm_date:AFM Date`,
  'Win Amount': $localize`:@@conversion.win_amount:Win Amount`,
  'Bet Amount': $localize`:@@conversion.bet_amount:Bet Amount`,
  'Chargeback Amount': $localize`:@@common.chargeback_amount:Chargeback Amount`,
  'Wagered Bonus': $localize`:@@conversion.wagered_bonus:Wagered Bonus`,
  'Bonus Cash': $localize`:@@conversion.bonus_cash:Bonus Cash`,
  'Net Gaming Cash': $localize`:@@conversion.net_gaming_cash:Net Gaming Cash`,
  Unique: $localize`:@@common.unique:Unique`,
  'Baseline Field': $localize`:@@common.baseline_field:Baseline Field`,
  'Baseline Amount': $localize`:@@common.baseline_amount:Baseline Amount`,
  Qualified: $localize`:@@common.qualified:Qualified`,
  'Click ID': $localize`:@@click.id:Click ID`,
  'Country Code': $localize`:@@common.country_code:Country Code`,
  Additional: $localize`:@@common.additional:Additional`,
  'AFM Date From': $localize`:@@common.afm_date_from:AFM Date From`,
  'AFM Date To': $localize`:@@common.afm_date_to:AFM Date To`,
  'Updated From': $localize`:@@common.updated_from:Updated From`,
  'Updated To': $localize`:@@common.updated_to:Updated To`,
  Timestamps: $localize`:@@common.timestamps:Timestamps`,
  Severity: $localize`:@@common.severity:Severity`,
  Affiliates: $localize`:@@common.affiliates:Affiliates`,
  'Employee ID': $localize`:@@common.employee_id:Employee ID`,
  'Hidden For Affiliates': $localize`:@@affiliate.hidden_for_affiliates:Hidden For Affiliates`,
  Method: $localize`:@@common.method:Method`,
  Currency: $localize`:@@common.currency:Currency`,
  Account: $localize`:@@common.account:Account`,
  'Has Conversions': $localize`:@@common.has_conversions:Has Conversions`,
  'Deposits Amount': $localize`:@@common.deposits_amount:Deposits Amount`,
  Lifetime: $localize`:@@common.lifetime:Lifetime`,
  'First name': $localize`:@@common.first_name:First Name`,
  'Last name': $localize`:@@common.last_name:Last Name`,
  'Advertiser External ID': $localize`:@@advertiser.external_id:Advertiser External ID`,
  Manager: $localize`:@@common.manager:Manager`,
  'Country And Region': $localize`:@@common.country_and_region:Country And Region`,
  'Local Skipping Count': $localize`:@@common.local_skipping_count:Local Skipping Count`,
  'Earning Period From': $localize`:@@common.earning_period_from:Earning Period From`,
  'Earning Period To': $localize`:@@common.earning_period_to:Earning Period To`,
  'Allow Deeplinks': $localize`:@@common.allow_deeplinks:Allow Deeplinks`,
  User: $localize`:@@common.user:User`,
  Expired: $localize`:@@common.expired:Expired`,
  'Active Until': $localize`:@@common.active_until:Active Until`,
  'User Name': $localize`:@@common.user_name:User Name`,
  Label: $localize`:@@common.label:Label`,
  'Show In Affiliate Area': $localize`:@@common.show_in_affiliate_area:Show In Affiliate Area`,
  'Referral Business Model': $localize`:@@settings.referral_business_models:Referral Business Models`,
  'Manually Created': $localize`:@@common.manually_created:Manually Created`,
  'Affiliate Answer': $localize`:@@affiliate.answer:Affiliate Answer`,
  'Charge Back Amount': $localize`:@@common.charge_back_amount:Charge Back Amount`,
  'Conversion Profiles': $localize`:@@conversion.profiles:Conversion Profiles`,
  'Offer URL ID': $localize`:@@offer.url_id:Offer URL ID`,
  Basic: $localize`:@@common.basic:Basic`,
  Dates: $localize`:@@common.dates:Dates`,
  'Affiliate Question': $localize`:@@affiliate.question:Affiliate Question`,
  Resolution: $localize`:@@common.resolution:Resolution`,
  Format: $localize`:@@common.format:Format`,
  'Image URL': $localize`:@@common.image_url:Image URL`,
  'Request Only': $localize`:@@common.request_only:Request Only`,
  Public: $localize`:@@common.public:Public`,
  Private: $localize`:@@common.private:Private`,
  conversion: $localize`:@@common.conversion:Conversion`,
  transaction: $localize`:@@common.transaction:Transaction`,
  Other: $localize`:@@common.other:Other`,
  'Privacy Policy': $localize`:@@common.privacy_policy:Privacy Policy`,
  'Terms and Conditions': $localize`:@@affiliate.terms_and_conditions:Terms and Conditions`,
  'Postback with Click ID': $localize`:@@common.postback_with_click_id:Postback with Click ID`,
  'iFrame pixel': $localize`:@@common.iframe_pixel:iFrame pixel`,
  'No Negative Carry Over': $localize`:@@affiliate.no_negative_carry_over:No Negative Carry Over`,
  'Master Fee': $localize`:@@transaction.master_fee:Master Fee`,
  'Referral Bonus': $localize`:@@common.referral_bonus:Referral Bonus`,
  'Referral Correction Entry': $localize`:@@transaction.referral_correction_entry:Referral Correction Entry`,
  'Affiliate and Advertiser': $localize`:@@common.affiliate_&_advertiser:Affiliate and Advertiser`,
  'Microsoft Teams (formerly Skype)': $localize`:@@common.ms_teams_formerly_skype:Microsoft Teams (formerly Skype)`,
  'User ID': $localize`:@@common.user_id:User ID`,
  'User Type': $localize`:@@common.user_type:User Type`,
  'Status Code': $localize`:@@common.status_code:Status Code`,
  'Created at': $localize`:@@common.created_at:Created At`,
  Action: $localize`:@@common.action:Action`,
};
